module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"gotIt":"Got it!","pleaseChooseAnImage":"Please choose an image file","fileTooBig":"Your file is too big! Please select an image under 1MB."},"es":{"gotIt":"¡Entendido!","pleaseChooseAnImage":"Por favor, selecciona una imagen","fileTooBig":"¡La imagen es muy pesada! Por favor selecciona una imagen con peso máximo de 1MB."}}')
  delete Component.options._Ctor
}
